<template>
  <v-container fluid class="permission-page">
    <section class="permission-hero">
      <div>
        <div class="permission-kicker">
          <span><v-icon small>fal fa-shield-check</v-icon></span>
          {{ $t("access_control") }}
        </div>
        <h1>{{ $t("permission") }}</h1>
        <p>{{ $t("settings_permission_intro") }}</p>
      </div>
      <div class="permission-hero__stats">
        <div><strong>{{ menus.length }}</strong><span>{{ $t("menu") }}</span></div>
        <div><strong>{{ permissions.length }}</strong><span>{{ $t("permission") }}</span></div>
      </div>
    </section>

    <section class="permission-section">
      <div class="permission-section__heading">
        <div>
          <h2>{{ $t("menu") }}</h2>
          <p>{{ $t("settings_menu_hint") }}</p>
        </div>
        <span>{{ menus.length }}</span>
      </div>
      <div class="permission-grid">
        <article
          v-for="(item, index) in menus"
          :key="index"
          class="permission-card"
          :style="{ '--permission-accent': getColor(index) }"
          @click="editItem(item)"
        >
          <div class="permission-card__icon">
            <i v-if="isLineIcon(item)" :class="item.icon" class="ps-perm-lni"></i>
            <v-icon v-else>{{ item.icon || "fal fa-bars" }}</v-icon>
          </div>
          <div class="permission-card__body">
            <h3>{{ $t(item.code) }}</h3>
            <p v-if="item.menu && item.menu.length">
              {{ item.menu.length }} {{ $t("sub_menus") }}
            </p>
            <p v-else>{{ item.to || $t("no_link") }}</p>
          </div>
          <v-icon class="permission-card__arrow" small>fal fa-arrow-up-right</v-icon>
        </article>
      </div>
    </section>

    <section class="permission-section permission-section--permissions">
      <div class="permission-section__heading">
        <div>
          <h2>{{ $t("permission") }}</h2>
          <p>{{ $t("settings_permission_hint") }}</p>
        </div>
        <span>{{ permissions.length }}</span>
      </div>
      <div class="permission-grid">
        <article
          v-for="(item, index) in permissions"
          :key="index"
          class="permission-card"
          :style="{ '--permission-accent': getColor(index + menus.length) }"
          @click="editItem(item)"
        >
          <div class="permission-card__icon">
            <i v-if="isLineIcon(item)" :class="item.icon" class="ps-perm-lni"></i>
            <v-icon v-else>{{ item.icon || "fal fa-shield-check" }}</v-icon>
          </div>
          <div class="permission-card__body">
            <h3>{{ $t(item.code) }}</h3>
            <p>{{ $t("function_permission") }}</p>
          </div>
          <v-icon class="permission-card__arrow" small>fal fa-arrow-up-right</v-icon>
        </article>
      </div>
    </section>

    <app-custom-dialog
      v-model="dialogMenu"
      :footer="false"
      :title="selectedMenu.code || 'sub_menus'"
      @submit="dialogMenu = false"
    >
      <div slot="activator">
        <v-list two-line>
          <v-list-item v-for="(sub, i) in selectedMenu.menu" :key="i">
            <v-list-item-avatar>
              <i v-if="isLineIcon(sub)" :class="sub.icon" class="ps-perm-lni ps-perm-lni--sm"></i>
              <v-icon v-else class="grey lighten-1 white--text">{{ sub.icon || "fal fa-circle" }}</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">{{ $t(sub.code) }}</v-list-item-title>
              <v-list-item-subtitle>{{ sub.code }}</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action><v-chip x-small>{{ sub.type || "user" }}</v-chip></v-list-item-action>
          </v-list-item>
        </v-list>
      </div>
    </app-custom-dialog>

    <app-custom-dialog v-model="dialog" :footer="false" title="description">
      <div slot="activator">
        <v-row>
          <v-col cols="4">ລະຫັດ</v-col><v-col cols="8">{{ form.id }}</v-col>
          <v-col cols="4">ຊື່</v-col><v-col cols="8">{{ form.name }}</v-col>
          <v-col cols="4">ລີ້ງ</v-col><v-col cols="8">{{ form.to }}</v-col>
          <v-col cols="4">{{ $t("date") }}</v-col><v-col cols="8">{{ form.created_at | moment }}</v-col>
        </v-row>
      </div>
    </app-custom-dialog>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { customerValidate } from "@/validations/shop";
import { success } from "@/controllers/alert";
import { myMixin } from "@/mixin/main";

export default {
  mixins: [customerValidate, myMixin],
  data: () => ({
    update: false,
    dialogAdd: false,
    dialog: false,
    dialogMenu: false,
    selectedMenu: {},
    selected: [],
    formShow: {},
    form: {},
  }),
  async created() {
    await this.fetchItem();
  },
  computed: {
    ...mapGetters({ roles: "index/roles" }),
    menus() {
      return this.roles.filter((item) => item.to !== null || item.menu.length > 0);
    },
    permissions() {
      return this.roles.filter((item) => item.to === null && item.menu.length === 0);
    },
  },
  methods: {
    isLineIcon(item) {
      const icon = item && item.icon;
      return typeof icon === "string" && (item.icon_type === "line" || /^lni\s/i.test(icon));
    },
    getColor(index) {
      return ["#5b39c9", "#168b78", "#2774c7", "#c87528", "#475569", "#b24b72"][index % 6];
    },
    ...mapActions({ fetch: "index/fetch" }),
    async fetchItem() {
      await this.fetch({ that: this, url: "menu_list", commit: "SET_ROLES" });
    },
    async editItem(item) {
      if (item.menu && item.menu.length > 0) {
        this.selectedMenu = item;
        this.dialogMenu = true;
        return;
      }
      try {
        const { data } = await this.$http.get(`roles_permission/${item.id}`);
        this.formShow = data.data;
        this.selected = Help.pluck(data.permissions, "name");
        this.dialogAdd = !this.dialogAdd;
      } catch (error) {
        console.log(error);
      }
    },
    async viewItem(item) {
      this.form = item;
      this.dialog = !this.dialog;
    },
    async submitForm() {
      let result;
      try {
        this.$v.form.$touch();
        if (!this.$v.form.$invalid) {
          result = await this.$http.post(
            this.update ? `permission_update/${this.form.id}` : "permission_add",
            this.form
          );
          if (result.data.status) {
            this.dialogAdd = !this.dialogAdd;
            await Help.clearForm(this.form, this);
            await this.fetchItem();
            await success(this, result.data.message);
          }
        }
      } catch (error) {
        console.log("error", error);
      }
    },
  },
};
</script>

<style scoped>
.permission-page { min-height: 100%; background: #f7f8fc; }
.permission-hero, .permission-section { max-width: 1320px; margin: 0 auto; }
.permission-hero { position: relative; display: flex; align-items: center; justify-content: space-between; gap: 24px; padding: 10px 2px 27px; border-bottom: 1px solid #dedee8; color: #252039; }
.permission-hero::after { display: none; }
.permission-kicker { display: flex; align-items: center; gap: 8px; color: #7865be; font-size: 11px; font-weight: 800; letter-spacing: .16em; text-transform: uppercase; }
.permission-kicker span { display: inline-flex; width: 34px; height: 34px; align-items: center; justify-content: center; border: 1px solid #d9d1f7; border-radius: 10px; background: #eeeafd; color: #5b39c9; }
.permission-hero h1 { margin: 12px 0 6px; color: #252039; font-size: clamp(30px, 4vw, 44px); font-weight: 800; letter-spacing: -.04em; }
.permission-hero p { max-width: 570px; margin: 0; color: #858a9b; font-size: 14px; line-height: 1.6; }
.permission-hero__stats { display: flex; gap: 1px; border: 1px solid #e2deef; border-radius: 14px; background: #fff; overflow: hidden; }
.permission-hero__stats div { display: flex; min-width: 82px; flex-direction: column; padding: 14px 16px; }
.permission-hero__stats div + div { border-left: 1px solid rgba(196, 181, 253, .15); }
.permission-hero__stats strong { color: #5b39c9; font-size: 28px; }
.permission-hero__stats span { color: #858a9b; font-size: 11px; }
.permission-section { margin-top: 34px; }
.permission-section--permissions { margin-top: 38px; }
.permission-section__heading { display: flex; align-items: flex-end; justify-content: space-between; margin-bottom: 18px; }
.permission-section__heading h2 { margin: 0; color: #252039; font-size: 21px; font-weight: 800; }
.permission-section__heading p { margin: 5px 0 0; color: #858a9b; font-size: 13px; }
.permission-section__heading > span { min-width: 34px; padding: 7px 11px; border-radius: 8px; background: #edeafb; color: #6451ba; font-size: 12px; font-weight: 800; text-align: center; }
.permission-grid { display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 14px; }
.permission-card { position: relative; display: flex; min-height: 146px; align-items: center; gap: 15px; padding: 20px; overflow: hidden; border: 1px solid #e8eaf2; border-radius: 16px; background: #fff; box-shadow: 0 8px 20px rgba(47, 39, 83, .04); cursor: pointer; transition: transform .2s ease, box-shadow .2s ease, border-color .2s ease; }
.permission-card:hover { border-color: var(--permission-accent); box-shadow: 0 14px 28px rgba(47, 39, 83, .09); transform: translateY(-3px); }
.permission-card__icon { display: flex; width: 48px; height: 48px; flex: 0 0 auto; align-items: center; justify-content: center; border-radius: 14px; background: color-mix(in srgb, var(--permission-accent) 12%, #fff); color: var(--permission-accent); }
.permission-card__icon .ps-perm-lni { color: var(--permission-accent); font-size: 21px; }
.permission-card__body { min-width: 0; flex: 1; }
.permission-card h3 { margin: 0; overflow: hidden; color: #292440; font-size: 15px; font-weight: 800; text-overflow: ellipsis; white-space: nowrap; }
.permission-card p { margin: 5px 0 0; overflow: hidden; color: #8a8e9c; font-size: 11px; text-overflow: ellipsis; white-space: nowrap; }
.permission-card__arrow { align-self: flex-start; color: #b5b8c3 !important; }
.permission-section--permissions .permission-card { min-height: 128px; }

/* Dark Mode Overrides */
.theme--dark.permission-page,
.theme--dark .permission-page {
  background: transparent !important;
}
.theme--dark .permission-hero {
  border-bottom-color: rgba(255, 255, 255, 0.08);
  color: #ffffff;
}
.theme--dark .permission-kicker {
  color: #a5b4fc;
}
.theme--dark .permission-kicker span {
  background: rgba(129, 140, 248, 0.15);
  border-color: rgba(129, 140, 248, 0.35);
  color: #c4b5fd;
}
.theme--dark .permission-hero h1 {
  color: #ffffff;
}
.theme--dark .permission-hero p {
  color: #94a3b8;
}
.theme--dark .permission-hero__stats {
  background: #1e1e2d;
  border-color: rgba(255, 255, 255, 0.08);
}
.theme--dark .permission-hero__stats div + div {
  border-left-color: rgba(255, 255, 255, 0.08);
}
.theme--dark .permission-hero__stats strong {
  color: #a5b4fc;
}
.theme--dark .permission-hero__stats span {
  color: #94a3b8;
}
.theme--dark .permission-section__heading h2 {
  color: #ffffff;
}
.theme--dark .permission-section__heading p {
  color: #94a3b8;
}
.theme--dark .permission-section__heading > span {
  background: rgba(129, 140, 248, 0.18);
  color: #c4b5fd;
}
.theme--dark .permission-card {
  background: #1e1e2d;
  border-color: rgba(255, 255, 255, 0.08);
  box-shadow: none;
}
.theme--dark .permission-card:hover {
  border-color: var(--permission-accent);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.35);
}
.theme--dark .permission-card__icon {
  background: color-mix(in srgb, var(--permission-accent) 22%, #1e1e2d);
}
.theme--dark .permission-card h3 {
  color: #ffffff;
}
.theme--dark .permission-card p {
  color: #94a3b8;
}
.theme--dark .permission-card__arrow {
  color: #64748b !important;
}

@media (max-width: 1100px) { .permission-grid { grid-template-columns: repeat(3, minmax(0, 1fr)); } }
@media (max-width: 800px) { .permission-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); } }
@media (max-width: 600px) { .permission-page { padding: 18px 12px 32px !important; } .permission-hero { align-items: stretch; flex-direction: column; padding: 26px 22px; } .permission-hero::after { display: none; } .permission-hero__stats { align-self: flex-start; } .permission-grid { grid-template-columns: 1fr; } .permission-section__heading { align-items: flex-start; } }
</style>
